<template>
    <div class="md-layout" :class="{ loading: !seasonStats.totalPot }">
      <div class="md-layout-item md-size-100">
        <h1 class="md-subheading gameStatsTitle">Game Stats - only top {{currentSeason.m}} games included in Total Points.</h1>
        <md-table class="gameStatsTable md-scrollbar" mdcard>
          <md-table-row>
            <md-table-head @click.native="sortStats('name')" class="statsPlayerName"><md-icon :class="{'statsSorted': sort.by === 'name', 'statsNotSorted': sort.by !== 'name'}">{{sortIcon}}</md-icon>Player</md-table-head>
            <md-table-head @click.native="sortStats('KOs')"><md-icon :class="{'statsSorted': sort.by === 'KOs', 'statsNotSorted': sort.by !== 'KOs'}">{{sortIcon}}</md-icon>KOs</md-table-head>
            <md-table-head @click.native="sortStats('totalPoints')"><md-icon :class="{'statsSorted': sort.by === 'totalPoints', 'statsNotSorted': sort.by !== 'totalPoints'}">{{sortIcon}}</md-icon>Points</md-table-head>
            <md-table-head @click.native="sortStats('handicap')"><md-icon :class="{'statsSorted': sort.by === 'handicap', 'statsNotSorted': sort.by !== 'handicap'}">{{sortIcon}}</md-icon>Handicap</md-table-head>
            <md-table-head v-for="game in seasonGames" :key="game.id" @click.native="sortStats('sort' + game.id)"><md-icon :class="{'statsSorted': sort.by === 'sort' + game.id, 'statsNotSorted': sort.by !== 'sort' + game.id}">{{sortIcon}}</md-icon>{{game.d}}</md-table-head>
          </md-table-row>
          <md-table-row v-for="stats in gameStats" :key="stats.id" @click.native="onSelect(stats.id)">
            <md-table-cell class="md-display-1" :class="{'statsPlayerNameEnabled': stats.yearEnd, 'statsPlayerNameDisabled': !stats.yearEnd}"><md-icon class="statsNotSorted">{{sortIcon}}</md-icon>{{stats.name}}</md-table-cell>
            <md-table-cell class="md-display-1">{{stats.KOs}}</md-table-cell>
            <md-table-cell class="md-display-1">{{stats.totalPoints}}</md-table-cell>
            <md-table-cell class="md-display-1">{{stats.handicap}}</md-table-cell>
            <md-table-cell class="md-display-1" v-for="game in seasonGames" :key="game.id" :class="{'cellStatNotCount': !stats['counts' + game.id]}">{{stats['show' + game.id]}}</md-table-cell>
          </md-table-row>
        </md-table>
      </div>
      <div class="md-layout-item md-size-50">
        <md-table md-card class="cardStatsPayouts">
            <md-table-toolbar class="cardHeadingToolbar">
                <h1 class="md-subheading">Season Payouts</h1>
            </md-table-toolbar>
            <md-table-row>
                <md-table-cell class="md-display-1 payoutCell">Total:</md-table-cell>
                <md-table-cell class="md-display-1 payoutCell">{{'$' + seasonStats.totalPot}}</md-table-cell>
            </md-table-row>
            <md-table-row v-for="(payout, index) in seasonStats.payouts" :key="index">
                <md-table-cell class="md-display-1 payoutCell" v-if="index === 0">First:</md-table-cell>
                <md-table-cell class="md-display-1 payoutCell" v-if="index === 1">Second:</md-table-cell>
                <md-table-cell class="md-display-1 payoutCell" v-if="index === 2">Third:</md-table-cell>
                <md-table-cell class="md-display-1 payoutCell">{{'$' + payout}}</md-table-cell>
            </md-table-row>
        </md-table>
      </div>
      <div class="md-layout-item md-size-50">
        <md-table md-card class="cardStatsPlayer">
          <md-table-toolbar class="cardHeadingToolbar">
              <h1 class="md-subheading">{{playerStatsTitle}}</h1>
          </md-table-toolbar>
          <md-table-row slot="md-table-row" v-for="stat in playerStats" :key="stat.id">
            <md-table-cell class="md-display-1 cellPlayerStat">{{stat.name}}</md-table-cell>
            <md-table-cell class="md-display-1 cellPlayerStat">{{stat.value}}</md-table-cell>
          </md-table-row>
        </md-table>
      </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'SeasonStats',
  data: function () {
    return {
      playerStats: [],
      playerStatsTitle: '',
      sort: {
        by: 'totalPoints',
        desc: true
      },
      gameStats: []
    }
  },
  computed: {
    ...mapState(['seasonStats', 'seasonGames']),
    ...mapGetters(['currentSeason']),
    sortIcon: function () {
      if (this.sort.desc) {
        return 'arrow_upward'
      } else {
        return 'arrow_downward'
      }
    }
  },
  mounted: function () {
    this.gameStats = this.calcGameStats()
  },
  watch: {
    seasonStats: function () {
      this.gameStats = this.calcGameStats()
    }
  },
  methods: {
    calcGameStats: function () {
      let arrayStats = []
      let playerKeys = Object.keys(this.seasonStats.players)
      for (let index = 0; index < playerKeys.length; index++) {
        const playerId = playerKeys[index]
        let player = this.seasonStats.players[playerId]
        let stats = {}
        stats.id = playerId
        stats.name = player.name
        stats.totalPoints = player.points + player.handicap
        stats.KOs = player.KOs
        stats.handicap = player.handicap
        stats.yearEnd = player.yearEnd
        for (let i = 0; i < this.seasonGames.length; i++) {
          const game = this.seasonGames[i]
          stats['name' + game.id] = game.d
          if (player.hasOwnProperty(game.id)) {
            stats['sort' + game.id] = player[game.id].points
            stats['show' + game.id] = player[game.id].points
            stats['counts' + game.id] = player[game.id].doesCount
          } else {
            stats['sort' + game.id] = -1
            stats['show' + game.id] = null
            stats['counts' + game.id] = false
          }
        }
        arrayStats.push(stats)
      }
      let sort = this.sort
      // If sorting by Total Points, sort in the following order of highest to lowest importance
      //   Total Points, Knockouts, and Handicap
      if (sort.by === 'totalPoints') {
        arrayStats.sort(function (a, b) {
          if (sort.asc) {
            return b.handicap - a.handicap
          } else {
            return a.handicap - b.handicap
          }
        })
        arrayStats.sort(function (a, b) {
          if (sort.desc) {
            return b.KOs - a.KOs
          } else {
            return a.KOs - b.KOs
          }
        })
        arrayStats.sort(function (a, b) {
          if (sort.desc) {
            return b.totalPoints - a.totalPoints
          } else {
            return a.totalPoints - b.totalPoints
          }
        })
      } else {
        arrayStats.sort(function (a, b) {
          if (sort.by === 'name') {
            let aSort = a.name.toUpperCase()
            let bSort = b.name.toUpperCase()

            if (sort.desc) {
              if (bSort > aSort) {
                return 1
              }
              if (bSort < aSort) {
                return -1
              }
              return 0
            } else {
              if (aSort > bSort) {
                return 1
              }
              if (aSort < bSort) {
                return -1
              }
              return 0
            }
          } else {
            if (sort.desc) {
              return b[sort.by] - a[sort.by]
            } else {
              return a[sort.by] - b[sort.by]
            }
          }
        })
      }
      return arrayStats
    },
    sortStats: function (value) {
      let sort = {}
      if (value === this.sort.by) {
        sort.by = value
        sort.desc = !this.sort.desc
      } else {
        sort.by = value
        sort.desc = !(value === 'name')
      }
      this.sort = sort
    },
    onSelect: function (playerId) {
      let player = this.seasonStats.players[playerId]
      let playerStats = []
      let playerName = player.name

      // Total Rebuys
      playerStats.push({name: 'No. of Rebuys', value: player.rebuys})

      // Total Topups
      playerStats.push({name: 'No. of Topups', value: player.topups})

      // Avg points per game
      let playedGames = 0
      let totalPoints = 0
      for (let index = 0; index < this.seasonGames.length; index++) {
        const game = this.seasonGames[index]
        if (player.hasOwnProperty(game.id)) {
          playedGames += 1
          totalPoints += player[game.id].points
        }
      }
      playerStats.push({name: 'Avg. Points per Game', value: parseFloat(totalPoints / playedGames).toFixed(2)})

      // Most knocked out and Most knocked out by
      let KOd = {}
      let KOdBy = {}
      for (let index = 0; index < this.seasonStats.KOs.length; index++) {
        const KO = this.seasonStats.KOs[index]
        if (KO.i1 === playerId) {
          if (KOdBy.hasOwnProperty(KO.i2)) {
            KOdBy[KO.i2] += 1
          } else {
            KOdBy[KO.i2] = 1
          }
        } else if (KO.i2 === playerId) {
          if (KOd.hasOwnProperty(KO.i1)) {
            KOd[KO.i1] += 1
          } else {
            KOd[KO.i1] = 1
          }
        }
      }
      let playerMostKOd = {times: 0, id: ''}
      let mostKOdByPlayer = {times: 0, id: ''}
      for (let index = 0; index < Object.keys(KOd).length; index++) {
        const KOdPlayerId = Object.keys(KOd)[index]
        if (KOd[KOdPlayerId] > playerMostKOd.times) {
          playerMostKOd.times = KOd[KOdPlayerId]
          playerMostKOd.id = KOdPlayerId
        }
      }
      for (let index = 0; index < Object.keys(KOdBy).length; index++) {
        const KOdByPlayerId = Object.keys(KOdBy)[index]
        if (KOdBy[KOdByPlayerId] > mostKOdByPlayer.times) {
          mostKOdByPlayer.times = KOdBy[KOdByPlayerId]
          mostKOdByPlayer.id = KOdByPlayerId
        }
      }
      let mostKOdName = 'No KOs'
      let mostKOdByName = 'Never KOd'
      if (playerMostKOd.id !== '') {
        mostKOdName = this.seasonStats.players[playerMostKOd.id].name + ' (' + playerMostKOd.times + ')'
      }
      if (mostKOdByPlayer.id !== '') {
        mostKOdByName = this.seasonStats.players[mostKOdByPlayer.id].name + ' (' + mostKOdByPlayer.times + ')'
      }
      playerStats.push({name: 'Most KOs / KOd by', value: mostKOdName + ' / ' + mostKOdByName})

      this.playerStats = playerStats
      this.playerStatsTitle = 'Stats for ' + playerName
    }
  }
}
</script>

<style lang="scss">
  .md-card.cardStatsPayouts {
    box-shadow: none;
    width: 33vw;
  }
  .md-card.cardStatsPlayer {
    box-shadow: none;
    width: 33vw;
  }
  .cellStatNotCount {
    color: black !important;
  }
  .statsSorted {
    font-size: 12px !important;
    opacity: 1;
    color: #ff9800 !important;
  }
  .statsNotSorted {
    font-size: 12px !important;
    opacity: 0.0;
  }
  .gameStatsTitle {
    padding-left: 16px;
  }
  .gameStatsTable {
    cursor:default;
    height: 33vw;
    box-shadow: none;
    width: 100%;
    padding-left: 16px;
  }
  .gameStatsTable .md-table-head-container {
    text-align: center;
    color: #ff9800 !important;
  }
  .statsPlayerName .md-table-head-container {
    text-align: left;
  }
  .gameStatsTable .md-table-head-label {
    padding-left: 0;
    padding-right: 0;
  }
  .gameStatsTable .md-table-cell-container
  {
    padding-left: 0;
    padding-right: 0;
    text-align: center;
  }
  .statsPlayerNameEnabled .md-table-cell-container {
    text-align: left;
    white-space: nowrap;
  }
  .statsPlayerNameDisabled .md-table-cell-container {
    text-align: left;
    white-space: nowrap;
    color: black !important;
  }
  .md-table .md-table-content {
    flex: 1 1 auto;
  }
  .loading {
    display: none;
  }
</style>
